<template>
  <svg
      :width="width"
      :height="height"
      :viewBox="`0 0 ${width} ${height}`"
      xmlns="http://www.w3.org/2000/svg"
  >

    <image v-if="imageUrl" :href="imageUrl" :width="width" :height="height" />

    <g v-for="(sub, index) in subDistricts" :key="index"
      class="district-map-group"
      :data-index="index">
      <path v-for="d in sub.svg" :d="d" />
    </g>
  </svg>


  <v-tooltip  v-for="(sub, index) in subDistricts" :key="index"
    v-model="show[index]"
    location="top"
    :target="`[data-index='${index}']`"
  >
    <div class="p-3">
      <h4>{{ sub.name }}</h4>
      <div>{{ sub.type }}</div>
    </div>
  </v-tooltip>
</template>

<script setup>
  import { ref, watch, onMounted } from "vue";

  const emit = defineEmits(['select']);
  const show = ref([]);
  const props = defineProps({
    subDistricts: {
      type: Array,
      required: false,
      default: []
    },
    width: {
      type: Number,
      required: false,
      default: 100
    },
    height: {
      type: Number,
      required: false,
      default: 100
    },
    imageUrl: {
      type: String,
      required: false,
      default: null
    }
  });

  watch(props.subDistricts, reset);

  function reset() {
    show.value = props.subDistricts.map(() => false);
    setTimeout(() => {
      document.querySelectorAll('svg g').forEach((group) => {
        group.removeEventListener('click', selectListener);
        group.removeEventListener('mouseenter', showTooltipListener);
        group.removeEventListener('mouseleave', hideTooltipListener);

        group.addEventListener('click', selectListener);
        group.addEventListener('mouseenter', showTooltipListener);
        group.addEventListener('mouseleave', hideTooltipListener);
      });
    }, 100);
  }

  function showTooltipListener(event) {
    const index = event.target.dataset.index
    show.value.forEach((_, i) => {
      show.value[i] = false;
    });
    show.value[index] = true
  }

  function hideTooltipListener(event) {
    const index = event.target.dataset.index
    show.value[index] = false
  }

  function selectListener(event) {
    event.preventDefault();
    const index = event.currentTarget.dataset.index
    if (index !== undefined) {
      show.value = [];
      emit("select", props.subDistricts[index]);
    }
  }
</script>

<style scoped>
  svg {
    max-width: 80%;
    max-height: 50vh;
    height: auto;
  }

  svg g {
    fill: #00000000;
    stroke: red;
    fill-rule: evenodd;
    stroke-width: 0.25%;
  }

  svg g:hover {
    fill: #002fff2e;
    stroke: #0055ff;
  }
</style>
